import React from "react";

import Badge from "components/Badge";

import { SideLoadedBusinessRow } from "constants/sideLoadedBusinesses";

interface SideLoadedBusinessValidityRendererProps {
  data: SideLoadedBusinessRow;
}

export function SideLoadedBusinessValidityRenderer({
  data,
}: SideLoadedBusinessValidityRendererProps) {
  const issues = data.validationIssues || [];

  if (!issues.length) {
    return <Badge color="successGreen">Valid</Badge>;
  }

  return (
    <div title={issues.join(", ")}>
      <Badge color="inputError">Invalid</Badge>
    </div>
  );
}
